import actions from './actions'

export default function TechnicianPartsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TECHNICIANPART:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TECHNICIANPART:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TECHNICIANPART:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TECHNICIANPART:
      return {
        ...state,
        editing: { technicianPartID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TECHNICIANPART_RECIEVED ||
      actions.UPDATE_TECHNICIANPART_RECIEVED ||
      actions.DELETE_TECHNICIANPART_RECIEVED:
      return {
        ...state,
        editing: { technicianPartID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
